class CurrentStepArray {
    constructor(...collection) {
        this._collection = collection;
        this._initCurrent();
    }
    
    _initCurrent() {
        if (this._collection.length > 0) {
            this._currentIndex = 0;
            return true;
        } else {
            this._currentIndex = undefined;
            return false;
        }
    }
    add(child) {
        this._collection.push(child);
    }
    remove(child = this.current) {        
        const index = this.indexOf(child);

        if (index > -1) {
            if (child === this.current) {
    
                if (this.current !== this.next) {
                    this.current = this.next;
                    this._collection.splice(index, 1);
                    this._currentIndex--;
                    return true;
                } else if (this.current !== this.prev) {
                    this.current = this.prev;
                    this._collection.splice(index, 1);
                    this._currentIndex--;
                    return true;                
                } else {
                    this.removeAll();
                    return false;                
                }
    
            } else {
                this._collection.splice(index, 1);
                if (this._currentIndex > index) {
                    this._currentIndex--;
                }
                return true;            
            }
        }
    }
    removeAll() {
        this._collection = [];
        this._initCurrent();
        return true;
    }
    get length() {
        return this._collection.length;
    }
    get current() {
        return this._collection[this._currentIndex];
    }
    set current(child) {
        const index = this.indexOf(child);
        if (index === this._currentIndex) return child;

        this._currentIndex = index;
    }
    get currentIndex() {
        return this._currentIndex;
    }
    get prev() {
        return this.go(-1, true);
    }
    get next() {
        return this.go(1, true);
    }
    indexOf(child) {
        return this._collection.indexOf(child);
    }
    go(num = 0, blank = false) {
        if (num !== 0) {
            const min = 0;
            const max = this._collection.length - 1;

            let result = Math.max(min, this.currentIndex + num);
            result = Math.min(max, result);

            if (blank) {
                return this._collection[result];
            }

            return this.current = this._collection[result];
        } else if (blank) {
            return this.current;
        }
    }
    goTo(index, blank = false) {
        return this.goToIndex(index, blank);
    }
    goToIndex(index, blank = false) {
        const min = 0;
        const max = this._collection.length - 1;

        let result = Math.min(max, Math.max(min, index));

        if (blank) {
            return this._collection[result];
        } else {
            return this.current = this._collection[result];
        }
    }
}

module.exports = CurrentStepArray;



// WEBPACK FOOTER //
// ./js/current-step-array.js